import * as THREE from "three";
import { RepeatWrapping } from "three";

import { const_var, params } from "../redux/reducers/reducer";
import { wallNameArrForValid } from "./Validation";

export const extrudeSettings = (depth, bevelThickness, bevelSize, bevelOffset, bevelSegments) => {
	const setting = {
		steps: 1,
		depth: depth,
		bevelEnabled: true,
		bevelThickness: bevelThickness ?? 0,
		bevelSize: bevelSize ?? 0,
		bevelOffset: bevelOffset ?? 0,
		bevelSegments: bevelSegments ?? 1
	};

	return setting;
};
export const textureAnisotropy = (gl, texture, repeatX, repeatY, rotate, newgl) => {
	let dynamicGL = gl != undefined ? gl.capabilities.getMaxAnisotropy() : newgl;

	if (texture != "" && texture != undefined) {
		texture.anisotropy = Math.min(dynamicGL, 50);
		texture.wrapS = texture.wrapT = RepeatWrapping;
		texture.rotation = rotate ? rotate : 0;
		texture.repeat.set(repeatX, repeatY);
	}
};
export const railModel = (width, height) => {
	const model = new THREE.Shape();
	model.moveTo(-width / 2, -height / 2);
	model.lineTo(-width / 2, height / 2);
	model.lineTo(width / 2, height / 2);
	model.lineTo(width / 2, -height / 2);
	model.closePath();

	return model;
};
export const wainscotModel = (width, height) => {
	const model = new THREE.Shape();
	model.moveTo(-width / 2 + 0.01, 0);
	model.lineTo(-width / 2 + 0.01, height);
	model.lineTo(width / 2 - 0.01, height);
	model.lineTo(width / 2 - 0.01, 0);
	model.closePath();

	return model;
};
export const wainscotTrimModel = (width, height) => {
	const model = new THREE.Shape();
	model.moveTo(width / 2, -height + 0.03);
	model.lineTo(width / 2, -0.04);
	model.lineTo(width / 2 - 0.005, -0.015);
	model.lineTo(0, 0);
	model.lineTo(0, -height + 0);
	model.closePath();

	return model;
};
export const jTrimModel = (width, height) => {
	const jTrimThickness = 0.01;

	const model = new THREE.Shape();
	model.moveTo(-0.07 / 2, height / 2);
	model.lineTo(-0.07 / 2, -height / 2 - jTrimThickness);
	model.lineTo(width / 2, -height / 2 - jTrimThickness);
	model.lineTo(width / 2, 0);
	model.lineTo(width / 2 - jTrimThickness, 0);
	model.lineTo(width / 2 - jTrimThickness, -height / 2);
	model.lineTo(-0.07 / 2 + jTrimThickness, -height / 2);
	model.lineTo(-0.07 / 2 + jTrimThickness, height / 2);
	model.closePath();

	return model;
};
export const railLoftModel = (thickness, pitch) => {
	const model = new THREE.Shape();
	model.moveTo(0, 0);
	model.lineTo(0, const_var.roofRegularDst);
	model.quadraticCurveTo(0, const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * pitch) / 12 / 10, const_var.roofRegularDst, const_var.roofRegularDst * 2 + (const_var.roofRegularDst * pitch) / 12);
	model.lineTo(const_var.roofRegularDst, const_var.roofRegularDst * 2 + (const_var.roofRegularDst * pitch) / 12 - thickness);
	model.quadraticCurveTo(0 + thickness, const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * pitch) / 12 / 10 - thickness, thickness, const_var.roofRegularDst);
	model.lineTo(thickness, 0);
	model.closePath();

	return model;
};

export const leanRoofLoftTrimModel = (pitch, width) => {
	const trimHeight = 0.2;
	const regularHeight = const_var.roofRegularDst * 2;
	const overHangLeftWidth = 0.05;

	const model = new THREE.Shape();
	model.moveTo(-overHangLeftWidth + trimHeight, 0.1);
	model.lineTo(-overHangLeftWidth + trimHeight, const_var.roofRegularDst + trimHeight / 2);
	model.quadraticCurveTo(
		-overHangLeftWidth + trimHeight,
		const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * pitch) / 12 / 10,
		-overHangLeftWidth + trimHeight / 2 + const_var.roofRegularDst,
		const_var.roofRegularDst * 2 + (const_var.roofRegularDst * pitch) / 12
	);
	model.lineTo(width - overHangLeftWidth, (pitch / 12) * width + regularHeight);
	model.lineTo(width - overHangLeftWidth, (pitch / 12) * width + trimHeight + regularHeight + 0.005);
	model.lineTo(-overHangLeftWidth + const_var.roofRegularDst, trimHeight + const_var.roofRegularDst * 2 + (const_var.roofRegularDst * pitch) / 12);
	model.quadraticCurveTo(-overHangLeftWidth, trimHeight + const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * pitch) / 12 / 10, -overHangLeftWidth, trimHeight + const_var.roofRegularDst);
	model.lineTo(-overHangLeftWidth, 0.1);
	model.closePath();

	return model;
};

export const roofBaseRailModel = () => {
	const model = new THREE.Shape();
	model.moveTo(-0.095, 0.04);
	model.lineTo(0.095, 0.04);
	model.lineTo(0.16, -0.02);
	model.lineTo(0.24, -0.02);
	model.lineTo(0.24, -0.025);
	model.lineTo(0.155, -0.025);
	model.lineTo(0.09, 0.035);
	model.lineTo(-0.09, 0.035);
	model.lineTo(-0.155, -0.025);
	model.lineTo(-0.24, -0.025);
	model.lineTo(-0.24, -0.02);
	model.lineTo(-0.16, -0.02);

	return model;
};

export const roofCutShape = () => {
	const model = new THREE.Shape();
	model.moveTo(-3.1, 1);
	model.lineTo(0, 1);
	model.lineTo(0, -1);
	model.lineTo(-3.1, -1);
	model.closePath();

	return model;
};

export const getWallDirOnCanvas = (wallName) => {
	let direction;
	if (
		wallName === "c_b_f_w" ||
		wallName === "c_b_f_s_w" ||
		wallName === "F_L_F_W" ||
		wallName === "F_L_F_S_W" ||
		wallName === "B_L_L_S_W" ||
		wallName === "L_L_F_W" ||
		wallName === "L_L_F_S_W" ||
		wallName === "R_L_F_W" ||
		wallName === "R_L_F_S_W" ||
		wallName === "G_F_L_F_W" ||
		wallName === "G_F_L_F_S_W" ||
		wallName === "G_B_L_B_W" ||
		wallName === "G_B_L_B_S_W" ||
		wallName === "G_L_L_R_W" ||
		wallName === "G_L_L_R_S_W" ||
		wallName === "G_R_L_L_W" ||
		wallName === "G_R_L_L_S_W" ||
		wallName === "N_L_L_F_W" ||
		wallName === "N_L_L_F_S_W" ||
		wallName === "N_R_L_F_W" ||
		wallName === "N_R_L_F_S_W"
	) {
		direction = "front";
	} else if (
		wallName === "c_b_l_w" ||
		wallName === "c_b_l_s_w" ||
		wallName === "c_b_r_s_l_w" ||
		wallName === "F_L_L_W" ||
		wallName === "F_L_L_S_W" ||
		wallName === "B_L_B_W" ||
		wallName === "B_L_R_S_W" ||
		wallName === "L_L_L_W" ||
		wallName === "L_L_L_S_W" ||
		wallName === "R_L_L_S_W" ||
		wallName === "G_F_L_L_W" ||
		wallName === "G_F_L_L_S_W" ||
		wallName === "G_B_L_R_W" ||
		wallName === "G_B_L_R_S_W" ||
		wallName === "G_L_L_F_W" ||
		wallName === "G_L_L_F_S_W" ||
		wallName === "G_R_L_B_W" ||
		wallName === "G_R_L_B_S_W" ||
		wallName === "N_L_L_S_W" ||
		wallName === "N_L_L_L_S_W" ||
		wallName === "N_R_L_L_S_W"
	) {
		direction = "left";
	} else if (
		wallName === "c_b_r_w" ||
		wallName === "c_b_r_s_w" ||
		wallName === "c_b_l_s_r_w" ||
		wallName === "F_L_R_W" ||
		wallName === "F_L_F_S_W" ||
		wallName === "B_L_F_W" ||
		wallName === "B_L_F_S_W" ||
		wallName === "L_L_R_S_W" ||
		wallName === "R_L_R_W" ||
		wallName === "R_L_R_S_W" ||
		wallName === "G_F_L_R_W" ||
		wallName === "G_F_L_R_S_W" ||
		wallName === "G_B_L_L_W" ||
		wallName === "G_B_L_L_S_W" ||
		wallName === "G_L_L_B_W" ||
		wallName === "G_L_L_B_S_W" ||
		wallName === "G_R_L_F_W" ||
		wallName === "G_R_L_F_S_W" ||
		wallName === "N_L_L_R_S_W" ||
		wallName === "N_R_L_R_W" ||
		wallName === "N_R_L_R_S_W"
	) {
		direction = "right";
	} else if (
		wallName === "c_b_b_w" ||
		wallName === "c_b_b_s_w" ||
		wallName === "F_L_R_S_W" ||
		wallName === "B_L_S_W" ||
		wallName === "B_L_B_S_W" ||
		wallName === "L_L_B_W" ||
		wallName === "L_L_B_S_W" ||
		wallName === "R_L_B_W" ||
		wallName === "R_L_B_S_W" ||
		wallName === "G_F_L_B_W" ||
		wallName === "G_F_L_B_S_W" ||
		wallName === "G_B_L_F_W" ||
		wallName === "G_B_L_F_S_W" ||
		wallName === "G_L_L_L_W" ||
		wallName === "G_L_L_L_S_W" ||
		wallName === "G_R_L_R_W" ||
		wallName === "G_R_L_R_S_W" ||
		wallName === "N_L_L_B_W" ||
		wallName === "N_L_L_B_S_W" ||
		wallName === "N_R_L_B_W" ||
		wallName === "N_R_L_B_S_W"
	) {
		direction = "back";
	}

	return direction;
};

export const delModel = (direction, section) => {
	const wallNameArr = {
		// center building part
		front: ["c_b_f_w", "c_b_l_s_f_w", "c_b_r_s_f_w", "F_L_B_S_W", "G_F_L_B_W"],
		back: ["c_b_b_w", "c_b_l_s_b_w", "c_b_r_s_b_w", "B_L_B_S_W", "G_B_L_B_W"],
		left: ["c_b_l_w", "c_b_l_s_w", "L_L_R_S_W", "c_b_f_s_l_w", "G_L_L_B_W"],
		right: ["c_b_r_w", "c_b_r_s_w", "R_L_L_S_W", "c_b_f_s_r_w", "G_R_L_B_W"],
		frontStorageFront: ["c_b_f_s_b_w"],
		backStorageFront: ["c_b_f_s_w"],
		backStorageRight: ["c_b_r_w", "c_b_r_s_w", "R_L_L_S_W", "c_b_f_s_r_w", "G_R_L_B_W"],
		backStorageLeft: ["c_b_l_w", "c_b_l_s_w", "L_L_R_S_W", "c_b_f_s_l_w"],
		backStorageBack: ["c_b_b_s_w"],
		leftStorageFront: ["c_b_l_s_r_w"],
		rightStorageFront: ["c_b_r_s_l_w"],

		// front-lean
		frontLeanFront: ["F_L_R_W"],
		frontLeanSide: ["F_L_F_W", "F_L_F_S_W"],
		frontLeanBack: ["F_L_L_W"],
		frontLeanStorageFront: ["F_L_R_S_W"],
		frontLeanStorageBack: ["F_L_L_S_W"],
		frontLeanStorageRight: ["c_b_f_w", "c_b_l_s_f_w", "c_b_r_s_f_w", "F_L_B_S_W"],

		// left-lean
		leftLeanFront: ["L_L_F_W"],
		leftLeanSide: ["L_L_L_W", "L_L_L_S_W"],
		leftLeanBack: ["L_L_B_W"],
		leftLeanStorageFront: ["L_L_F_S_W"],
		leftLeanStorageBack: ["L_L_B_S_W"],
		leftLeanStorageRight: ["c_b_l_w", "c_b_l_s_w", "L_L_R_S_W", "c_b_f_s_l_w"],

		// right-lean
		rightLeanFront: ["R_L_F_W"],
		rightLeanSide: ["R_L_R_W", "R_L_R_S_W"],
		rightLeanBack: ["R_L_B_W"],
		rightLeanStorageFront: ["R_L_F_S_W"],
		rightLeanStorageBack: ["R_L_B_S_W"],
		rightLeanStorageLeft: ["c_b_r_w", "c_b_r_s_w", "R_L_L_S_W", "c_b_f_s_r_w"],

		// back-lean
		backLeanFront: ["B_L_F_W"],
		backLeanSide: ["B_L_S_W", "B_L_F_S_W"],
		backLeanBack: ["B_L_B_W"],
		backLeanStorageFront: ["B_L_L_S_W"],
		backLeanStorageBack: ["B_L_R_S_W"],
		backLeanStorageRight: ["c_b_b_w", "c_b_l_s_b_w", "c_b_r_s_b_w", "B_L_B_S_W"],

		// gable front-lean
		gableFrontLeanFront: ["G_F_L_F_W"],
		gableFrontLeanLeft: ["G_F_L_L_W", "G_F_L_L_S_W"],
		gableFrontLeanRight: ["G_F_L_R_W", "G_F_L_R_S_W"],
		gableFrontLeanBack: ["G_F_L_B_W", "c_b_f_w", "c_b_l_s_f_w", "c_b_r_s_f_w"],
		gableFrontLeanStorageFront: ["G_F_L_F_S_W"],
		gableFrontLeanStorageBack: ["G_F_L_B_S_W"],

		// gable back-lean
		gableBackLeanFront: ["G_B_L_F_W"],
		gableBackLeanLeft: ["G_B_L_L_W", "G_B_L_L_S_W"],
		gableBackLeanRight: ["G_B_L_R_W", "G_B_L_R_S_W"],
		gableBackLeanBack: ["G_B_L_B_W", "c_b_b_w", "c_b_l_s_b_w", "c_b_r_s_b_w"],
		gableBackLeanStorageFront: ["G_B_L_F_S_W"],
		gableBackLeanStorageBack: ["G_B_L_B_S_W"],

		// gable left-lean
		gableLeftLeanFront: ["G_L_L_F_W"],
		gableLeftLeanLeft: ["G_L_L_L_W", "G_L_L_L_S_W"],
		gableLeftLeanRight: ["G_L_L_R_W", "G_L_L_R_S_W"],
		gableLeftLeanBack: ["G_L_L_B_W", "c_b_l_w", "c_b_l_s_w"],
		gableLeftLeanStorageFront: ["G_L_L_F_S_W"],
		gableLeftLeanStorageBack: ["G_L_L_B_S_W"],

		// gable right-lean
		gableRightLeanFront: ["G_R_L_F_W"],
		gableRightLeanLeft: ["G_R_L_L_W", "G_R_L_L_S_W"],
		gableRightLeanRight: ["G_R_L_R_W", "G_R_L_R_S_W"],
		gableRightLeanBack: ["G_R_L_B_W", "c_b_r_w", "c_b_r_s_w"],
		gableRightLeanStorageFront: ["G_R_L_F_S_W"],
		gableRightLeanStorageBack: ["G_R_L_B_S_W"]
	};

	let directionNameArr = "";
	let wallCloseState = "";
	let offsetValue = 1;

	switch (direction) {
		// center building part
		case "front":
			directionNameArr = wallNameArr[direction];
			if (section === "wall") {
				wallCloseState = params.p_f_w;
				if (params.cB_addStorage_check_right || params.cB_addStorage_check_left) wallCloseState = "Closed";
			} else if (section === "leg") {
				wallCloseState = "Closed";
			}
			if (wallCloseState === "Open" && params.add_front_lean) wallCloseState = "Gable";
			offsetValue = 1;
			break;
		case "back":
			directionNameArr = wallNameArr[direction];
			if (section === "wall") {
				wallCloseState = params.p_b_w;
				if (params.cB_addStorage_check_right || params.cB_addStorage_check_left) wallCloseState = "Closed";
			} else if (section === "leg") {
				wallCloseState = "Closed";
			}
			if (wallCloseState === "Open" && params.add_back_lean) wallCloseState = "Gable";
			offsetValue = -1;
			break;
		case "left":
			directionNameArr = wallNameArr[direction];
			if (section === "wall") {
				wallCloseState = params.p_l_w;
				if (params.p_u_c || params.cB_addStorage_check_left) wallCloseState = "Closed";
			} else if (section === "leg") {
				wallCloseState = "Closed";
			}
			if (wallCloseState === "Open" && params.add_left_lean) wallCloseState = "Gable";
			offsetValue = 1;
			break;
		case "right":
			directionNameArr = wallNameArr[direction];
			if (section === "wall") {
				wallCloseState = params.p_r_w;
				if (params.p_u_c || params.cB_addStorage_check_right) wallCloseState = "Closed";
			} else if (section === "leg") {
				wallCloseState = "Closed";
			}
			if (wallCloseState === "Open" && params.add_right_lean) wallCloseState = "Gable";
			offsetValue = -1;
			break;
		case "frontStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "backStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "backStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "backStorageRight":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "backStorageLeft":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "leftStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			if (section === "wall") {
				offsetValue = 1;
			} else if (section === "leg") {
				offsetValue = -1;
			}
			break;
		case "rightStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			if (section === "wall") {
				offsetValue = -1;
			} else if (section === "leg") {
				offsetValue = 1;
			}
			break;

		// front-lean
		case "frontLeanFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_f_f;
			offsetValue = 1;
			break;
		case "frontLeanSide":
			directionNameArr = wallNameArr[direction];
			if (section === "wall") {
				wallCloseState = params.p_b_c_b_f_l;
				if (params.add_storage_check_front) wallCloseState = "Closed";
			} else if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = 1;
			break;
		case "frontLeanBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "frontLeanStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "frontLeanStorageRight":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "frontLeanStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;

		case "gableFrontLeanFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_f_f;
			offsetValue = 1;
			break;

		case "gableFrontLeanLeft":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_f_l;
			if (params.add_storage_check_front) {
				wallCloseState = "Closed";
			}
			if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = -1;
			break;

		case "gableFrontLeanRight":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_f_r;
			if (params.add_storage_check_front) {
				wallCloseState = "Closed";
			}
			if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = 1;
			break;

		case "gableFrontLeanBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_f_b;
			offsetValue = section === "leg" ? -1 : 1;
			break;

		case "gableFrontLeanStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;

		case "gableFrontLeanStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;

		// left-lean
		case "leftLeanFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_l_f;
			offsetValue = 1;
			break;
		case "leftLeanSide":
			directionNameArr = wallNameArr[direction];
			if (section === "wall") {
				wallCloseState = params.p_b_c_b_l;
				if (params.add_storage_check) wallCloseState = "Closed";
			} else if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = -1;
			break;
		case "leftLeanBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_l_b;
			offsetValue = -1;
			break;
		case "leftLeanStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "leftLeanStorageRight":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "leftLeanStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "gableLeftLeanFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_l_f;
			offsetValue = -1;
			break;
		case "gableLeftLeanLeft":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_l;
			if (params.add_storage_check) {
				wallCloseState = "Closed";
			}
			if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = -1;
			break;
		case "gableLeftLeanRight":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_l;
			if (params.add_storage_check) {
				wallCloseState = "Closed";
			}
			if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = 1;
			break;
		case "gableLeftLeanBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_l_b;
			offsetValue = 1;
			break;
		case "gableLeftLeanStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "gableLeftLeanStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;

		// right-lean
		case "rightLeanFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_r_f;
			offsetValue = 1;
			break;
		case "rightLeanSide":
			directionNameArr = wallNameArr[direction];
			if (section === "wall") {
				wallCloseState = params.p_b_c_b_r;
				if (params.add_storage_check_right) wallCloseState = "Closed";
			} else if (section === "leg") {
				wallCloseState = "Closed";
			}

			offsetValue = 1;
			break;
		case "rightLeanBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_r_b;
			offsetValue = -1;
			break;
		case "rightLeanStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "rightLeanStorageLeft":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "rightLeanStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "gableRightLeanFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_r_f;
			offsetValue = -1;
			break;
		case "gableRightLeanLeft":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_r;
			if (params.add_storage_check_right) {
				wallCloseState = "Closed";
			}
			if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = 1;
			break;
		case "gableRightLeanRight":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_r;
			if (params.add_storage_check_right) {
				wallCloseState = "Closed";
			}
			if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = -1;
			break;
		case "gableRightLeanBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_r_b;
			offsetValue = 1;
			break;
		case "gableRightLeanStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "gableRightLeanStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		// back-lean
		case "backLeanFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_b_f;
			offsetValue = 1;
			break;
		case "backLeanSide":
			directionNameArr = wallNameArr[direction];
			if (section === "wall") {
				wallCloseState = params.p_b_c_b_b_l;
				if (params.add_storage_check_back) wallCloseState = "Closed";
			} else if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = -1;
			break;
		case "backLeanBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_b_b;
			offsetValue = -1;
			break;
		case "backLeanStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "backLeanStorageRight":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "backLeanStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = -1;
			break;
		case "gableBackLeanFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_b_f;
			offsetValue = 1;
			break;
		case "gableBackLeanLeft":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_b_l;
			if (params.add_storage_check_back) {
				wallCloseState = "Closed";
			}
			if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = 1;
			break;
		case "gableBackLeanRight":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_b_l;
			if (params.add_storage_check_back) {
				wallCloseState = "Closed";
			}
			if (section === "leg") {
				wallCloseState = "Closed";
			}
			offsetValue = -1;
			break;
		case "gableBackLeanBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = params.p_b_c_b_b_b;
			offsetValue = 1;
			break;
		case "gableBackLeanStorageFront":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		case "gableBackLeanStorageBack":
			directionNameArr = wallNameArr[direction];
			wallCloseState = "Closed";
			offsetValue = 1;
			break;
		default:
	}

	let modelGroup = [];
	const filterDoorsArr = const_var.newDoorsArray.filter((item) => directionNameArr.includes(item.userData.wallName));
	if (filterDoorsArr.length > 0) {
		filterDoorsArr.map((item) => {
			let additionalOffset = 1;
			const width = item.width;
			const height = item.height;
			const pos_x = item.positionX;
			const pos_y = item.positionY;

			if (direction === "leftLeanStorageRight") {
				offsetValue = item.userData.wallName === "L_L_R_S_W" ? 1 : -1;
			} else if (direction === "rightLeanStorageLeft") {
				offsetValue = item.userData.wallName === "R_L_L_S_W" ? -1 : 1;
			}

			if (
				(direction === "front" && directionNameArr.filter((item) => !item.includes("c_b_")).includes(item.userData.wallName)) ||
				(direction === "gableFrontLeanBack" && directionNameArr.filter((item) => item.includes("c_b_")).includes(item.userData.wallName)) ||
				(direction === "back" && directionNameArr.filter((item) => !item.includes("c_b_")).includes(item.userData.wallName)) ||
				(direction === "gableBackLeanBack" && directionNameArr.filter((item) => item.includes("c_b_")).includes(item.userData.wallName)) ||
				(direction === "left" && directionNameArr.filter((item) => !item.includes("c_b_")).includes(item.userData.wallName)) ||
				(direction === "gableLeftLeanBack" && directionNameArr.filter((item) => item.includes("c_b_")).includes(item.userData.wallName)) ||
				(direction === "right" && directionNameArr.filter((item) => !item.includes("c_b_")).includes(item.userData.wallName)) ||
				(direction === "gableRightLeanBack" && directionNameArr.filter((item) => item.includes("c_b_")).includes(item.userData.wallName))
			) {
				additionalOffset = -1;
			}

			if (item.userData.compType === "garage_door" || item.userData.compType === "garage_door_frameout" || item.userData.compType === "walkin" || item.userData.compType === "walkin_frameout") {
				if ((section === "leg" && item.userData.compType.includes("frameout")) || !item.userData.compType.includes("frameout") || wallCloseState !== "Open") {
					let trimOffset;
					if (width >= 2.5) {
						trimOffset = 1;
					} else {
						trimOffset = width / 3;
					}
					const model = new THREE.Shape();
					if (item.userData.compName === "standard_trim_door") {
						model.moveTo(pos_x * offsetValue * additionalOffset - width / 2, 0);
						model.lineTo(pos_x * offsetValue * additionalOffset - width / 2, height - trimOffset);
						model.lineTo(pos_x * offsetValue * additionalOffset - width / 2 + trimOffset, height);
						model.lineTo(pos_x * offsetValue * additionalOffset + width / 2 - trimOffset, height);
						model.lineTo(pos_x * offsetValue * additionalOffset + width / 2, height - trimOffset);
						model.lineTo(pos_x * offsetValue * additionalOffset + width / 2, 0);
						model.closePath();
					} else if (item.userData.compName === "double_slider_door_door") {
						return null;
					} else {
						model.moveTo(pos_x * offsetValue * additionalOffset - width / 2, 0);
						model.lineTo(pos_x * offsetValue * additionalOffset - width / 2, height);
						model.lineTo(pos_x * offsetValue * additionalOffset + width / 2, height);
						model.lineTo(pos_x * offsetValue * additionalOffset + width / 2, 0);
						model.closePath();
					}

					modelGroup.push(model);
				}
			} else if ((item.userData.compType === "window" || item.userData.compType === "window_frameout") && item.userData.compName != "faux_window_window") {
				if ((section === "leg" && item.userData.compType.includes("frameout")) || !item.userData.compType.includes("frameout") || wallCloseState !== "Open") {
					const model = new THREE.Shape();
					model.moveTo(pos_x * offsetValue * additionalOffset - width / 2, pos_y - height / 2);
					model.lineTo(pos_x * offsetValue * additionalOffset - width / 2, pos_y + height / 2);
					model.lineTo(pos_x * offsetValue * additionalOffset + width / 2, pos_y + height / 2);
					model.lineTo(pos_x * offsetValue * additionalOffset + width / 2, pos_y - height / 2);
					model.closePath();

					modelGroup.push(model);
				}
			}

			return null;
		});
	}

	return modelGroup;
};
export const sortDoorObject = (sideArray) => {
	const sort = sideArray.sort((door1, door2) => {
		return door1["positionX"] - door2["positionX"];
	});
	return sort;
};
export const getMaxHeight = (sideArray) => {
	let maxHeight = -Infinity;

	for (let obj of sideArray) {
		if (obj.hasOwnProperty("height") && typeof obj.height === "number") {
			if (obj.height > maxHeight) {
				maxHeight = obj.height;
			}
		}
	}

	return maxHeight;
};
export const convertSizeFormat = (size, type) => {
	const parts = size.split("x");

	if (parts.length === 2) {
		const width = parts[0];
		const height = parts[1];
		if (type === "door") return `${width}'x${height}'`;
		else if (type === "window" || type === "walkin") return `${width}"x${height}"`;
	}

	return size;
};

const keyPatternIncrements = [
	{ x: 0.015, y: 0.045 },
	{ x: 0.03, y: 0.045 },
	{ x: 0.045, y: 0.06 },
	{ x: 0.06, y: 0.06 },
	{ x: 0.075, y: 0.06 },
	{ x: 0.09, y: 0.045 },
	{ x: 0.105, y: 0.045 },
	{ x: 0.12, y: 0 },
	{ x: 0.28, y: 0 },
	{ x: 0.2967, y: 0.018 },
	{ x: 0.3134, y: 0.018 },
	{ x: 0.3301, y: 0.018 },
	{ x: 0.3468, y: 0 },
	{ x: 0.5068, y: 0 },
	{ x: 0.5235, y: 0.018 },
	{ x: 0.5402, y: 0.018 },
	{ x: 0.5569, y: 0.018 },
	{ x: 0.5736, y: 0 }
];

export const roofPattern = (patternLength, isPattern, isRoof) => {
	const step = 0.7336;
	const points = [];
	let shouldSimplify = params.wallTexture != "none" || isPattern == false ? (isRoof == "roof" && isPattern == true ? true : false) : true;

	// Add multiple points at once to reduce function overhead
	points.push(new THREE.Vector2(0, -0.005), new THREE.Vector2(0, 0));

	// Cache keyPatternIncrements length for loop optimization
	const keyPatternCount = keyPatternIncrements.length;

	// Use a for-loop to reduce overhead compared to a while-loop
	for (let i = 0; i <= patternLength; i += step) {
		const nextStep = i + step;

		if (nextStep <= patternLength && shouldSimplify) {
			// Precompute and add all points from increments in one loop
			for (let j = 0; j < keyPatternCount; j++) {
				const { x, y } = keyPatternIncrements[j];
				points.push(new THREE.Vector2(i + x, y));
			}
			points.push(new THREE.Vector2(nextStep, 0));
		} else {
			// Handle case when pattern length is reached
			for (let j = 0; j < keyPatternCount; j++) {
				const { x, y } = keyPatternIncrements[j];
				if (i + x <= patternLength && shouldSimplify) points.push(new THREE.Vector2(i + x, y));
			}
			points.push(new THREE.Vector2(patternLength, 0), new THREE.Vector2(patternLength, -0.005));
			break;
		}
	}

	const model = new THREE.Shape(points);
	model.closePath();
	return model;
};

export const roofPatternCurve = (sign, pitch, isPattern) => {
	const thickness = 0.015;
	const pitchNumber = typeof pitch === "number" ? pitch : typeof pitch === "string" ? Number(pitch) : undefined;

	const offset = (val) => {
		if (isPattern && !isNaN(pitchNumber)) {
			return val * ((pitchNumber - 3) / 12);
		}
		return 0;
	};

	const model = new THREE.Shape();
	if (isPattern) {
		model.moveTo(thickness, 0);
		model.lineTo(thickness, -0.01);
		model.lineTo(0, -0.01);
		model.lineTo(0, 0);
		keyPatternIncrements.forEach((item) => {
			if (item.x <= const_var.roofRegularDst) model.lineTo(-item.y, item.x);
		});
		model.lineTo(0, const_var.roofRegularDst);
		//
		keyPatternIncrements.forEach((item, index) => {
			if (index < 8) model.lineTo(-item.y, const_var.roofRegularDst + item.x);
		});
		model.lineTo(0.06, 0.7875 + offset(0.06));
		model.lineTo(0.053, 0.8195 + offset(0.053));
		model.lineTo(0.0775, 0.8555 + offset(0.0775));
		model.lineTo(0.1078, 0.8555 + offset(0.1078));
		model.lineTo(0.23, 0.9775 + offset(0.23));
		model.lineTo(0.23, 1.0095 + offset(0.23));
		model.lineTo(0.262, 1.031 + offset(0.262));
		model.lineTo(0.29, 1.0185 + offset(0.29));
		//
		model.lineTo(const_var.roofRegularDst, const_var.roofRegularDst * 2 + const_var.roofRegularDst * (pitchNumber / 12));
		model.lineTo(const_var.roofRegularDst, const_var.roofRegularDst * 2 + const_var.roofRegularDst * (pitchNumber / 12) - thickness);
		model.quadraticCurveTo(thickness * 2, const_var.roofRegularDst * 1.9 - thickness, thickness, const_var.roofRegularDst);
	} else {
		model.moveTo(0, -0.01);
		model.lineTo(0, const_var.roofRegularDst);
		model.quadraticCurveTo(0, const_var.roofRegularDst * 1.8, const_var.roofRegularDst, const_var.roofRegularDst * 2 + (const_var.roofRegularDst * pitchNumber) / 12);
		model.lineTo(const_var.roofRegularDst, const_var.roofRegularDst * 2 + (const_var.roofRegularDst * pitchNumber) / 12 - thickness);
		model.quadraticCurveTo(0 + thickness, const_var.roofRegularDst * 1.8 - thickness, thickness, const_var.roofRegularDst);
	}
	model.closePath();

	return model;
};

// LADDER Truss bottom rail shape
export const ladderTrussBottomRailModel = (railLength) => {
	const model = new THREE.Shape();
	model.moveTo(0, 0);
	model.lineTo(0, -railLength);
	model.lineTo(-0.1, -railLength - 0.3);
	model.lineTo(-0.25, -railLength - 0.2);
	model.lineTo(-0.2, -railLength);
	model.lineTo(-0.2, railLength);
	model.lineTo(-0.25, railLength + 0.2);
	model.lineTo(-0.1, railLength + 0.3);
	model.lineTo(0, railLength);
	model.closePath();

	return model;
};

// Function to darken a color by a given percentage
export const darkenColor = (hex, percent) => {
	// Parse the hex color
	hex = hex.replace(/^#/, "");
	const r = parseInt(hex.substr(0, 2), 16);
	const g = parseInt(hex.substr(2, 2), 16);
	const b = parseInt(hex.substr(4, 2), 16);

	// Calculate the darker color
	const darkerR = Math.round((r * (100 - percent)) / 100);
	const darkerG = Math.round((g * (100 - percent)) / 100);
	const darkerB = Math.round((b * (100 - percent)) / 100);

	// Convert back to hex
	const darkerHex = "#" + ((1 << 24) + (darkerR << 16) + (darkerG << 8) + darkerB).toString(16).slice(1);

	return darkerHex;
};

export const revertPosOfCmp = (doorsArray, wallName) => {
	doorsArray.forEach((item) => {
		const isValidWall = wallNameArrForValid
			.find((subArray) => subArray.includes(wallName))
			.filter((validWall) => validWall !== wallName)
			.includes(item.userData.wallName);
		if (!const_var.isEdit && isValidWall) {
			if (
				(["c_b_f_w", "c_b_l_s_f_w", "c_b_r_s_f_w"].includes(wallName) && ["F_L_B_S_W", "G_F_L_B_W"].includes(item.userData.wallName)) ||
				(["F_L_B_S_W", "G_F_L_B_W"].includes(wallName) && ["c_b_f_w", "c_b_l_s_f_w", "c_b_r_s_f_w"].includes(item.userData.wallName)) ||
				(["c_b_b_w", "c_b_l_s_b_w", "c_b_r_s_b_w"].includes(wallName) && ["B_L_B_S_W", "G_B_L_B_W"].includes(item.userData.wallName)) ||
				(["B_L_B_S_W", "G_B_L_B_W"].includes(wallName) && ["c_b_b_w", "c_b_l_s_b_w", "c_b_r_s_b_w"].includes(item.userData.wallName)) ||
				(["c_b_l_w", "c_b_l_s_w", "c_b_f_s_l_w"].includes(wallName) && ["L_L_R_S_W", "G_L_L_B_W"].includes(item.userData.wallName)) ||
				(["L_L_R_S_W", "G_L_L_B_W"].includes(wallName) && ["c_b_l_w", "c_b_l_s_w", "c_b_f_s_l_w"].includes(item.userData.wallName)) ||
				(["c_b_r_w", "c_b_r_s_w", "c_b_f_s_r_w"].includes(wallName) && ["R_L_L_S_W", "G_R_L_B_W"].includes(item.userData.wallName)) ||
				(["R_L_L_S_W", "G_R_L_B_W"].includes(wallName) && ["c_b_r_w", "c_b_r_s_w", "c_b_f_s_r_w"].includes(item.userData.wallName))
			) {
				item.positionX *= -1;
			}
		}
	});
};

export const getCamDstForSelectedWall = (size) => size / (2 * Math.tan(THREE.MathUtils.degToRad(const_var.controls.object.fov) / 2));

export const getDistanceTwoPoints = (position1, position2) => {
	const dx = position1.x - position2[0];
	const dy = position1.y - position2[1];
	const dz = position1.z - position2[2];

	return Math.sqrt(dx * dx + dy * dy + dz * dz);
};
/**
 * Retrieves the custom name for a given key from an object, or returns the key if no custom name is found.
 *
 * @param {Object} obj - The object containing the custom names.
 * @param {string} key - The key for which to retrieve the custom name.
 * @returns {string} - The custom name associated with the key, or the key itself if no custom name is found.
 */
export const getRoofPitchLabel = (obj, key) => {
	return obj[key]?.custom_name ?? key;
};

export const getLeantoRoofPitchLabel = (key) => {
	const leantoDataSources = [const_var.leanGetDataBack, const_var.leanGetDataRight, const_var.leanGetDataLeft, const_var.leanGetDataFront];

	// Find the first non-empty data source
	const roofPitch = leantoDataSources.find((data) => data?.roof_pitch)?.roof_pitch || [];

	const roofPitchObj = roofPitch.find((obj) => key === obj.roof_pitch && obj.roof_ids.includes(params.p_r_s));

	if (roofPitchObj?.custom_name) {
		return roofPitchObj.custom_name;
	}
	return key;
};
